<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 21/11/2021
  -->

<template>
	<div>
		<div v-for="(option, index) in dataArray" :key="index"
			 :class="{disableClick: disabled}"
			 @click="onOptionClicked">
			<el-option :key="getOptionValue(option)"
					   :label="getOptionLabel(option)"
					   :value="getOptionValue(option)"
					   :disabled="disabledKey ? option[disabledKey] : false">
				<slot :option="option" :index="index">
					<div>
						{{ getOptionLabel(option) }}
						<ToolTipView v-if="option.tooltip" :text="option.tooltip"/>
					</div>
				</slot>
			</el-option>
		</div>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "SelectOptionsContainer",
	components: {ToolTipView},
	extends: BaseComponent,

	props: {
		dataArray: {Array, required: true},
		disabled: Boolean,
		disabledKey: String
	},

	methods: {
		onOptionClicked(event) {
			if (this.disabled) {
				event.preventDefault()
			}
		},

        getOptionLabel(option){
            let res = this.emitResult('getOptionLabel', option)
            // console.log("getOptionLabel res = ", res)
            return res || "not-set"
        },
        getOptionValue(option){
            let res = this.emitResult('getOptionValue', option)
            // console.log("getOptionLabel res = ", res, ", option = ", option)
            return res
        }
	},
}
</script>

<style lang="scss">

</style>
